import React,{useState,useEffect} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import Navbar from './components/Navbar'
import Home from './components/Home'
import Blog from './components/Blog'
import Blogdes from './components/blog/Blogdes'
import Events from './components/Events'
import Loader from './components/Loader';
import Footer from './components/Footer';
import './App.css';

function App() {
  
  useEffect(()=>{
    setLoading(true)
    setTimeout(()=>{
      setLoading(false)
    },4000)
  },[])

  const [loading, setLoading] = useState(false)

  return (
    <>
    {
      loading 
      ? 
      <Loader/>
      :
      <BrowserRouter>
      <Navbar/>
      <Switch>
      <Route exact path='/' component={Home}/>
      <Route exact path='/blog' component={Blog}/>
      <Route path='/blog/:id' component={Blogdes}/>
      <Route path='/events' component={Events}/>
      </Switch>
      <Footer/>
      </BrowserRouter>
    }
    </>
  );
}

export default App;
